module.exports = __webpack_public_path__ + "static/media/logo1.45781df0.png";